<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="projects"
      :loading="Loading"
      item-key="_id"
      :style="
        bordered === true
          ? 'border: 1px solid rgba(0, 0, 0, 0.12)'
          : 'border: initial'
      "
    >
      <template v-slot:item.title="{ item }">
        <span>{{ item.title }}</span>
      </template>

      <template v-slot:item.status="{ item }">
        <ProjectStatusChip :item="item" />
      </template>

      <template v-slot:item.statusDesc="{ item }">
        <span>{{ item.status }}</span>
      </template>
      <template v-slot:item.analysisStatus="{ item }">
        <span>{{ item.analysisStatus }}</span>
      </template>

      <template v-slot:item.isPublished="{ item }">
        <PublishedChip :item="item" />
      </template>

      <template v-slot:item._deleted="{ item }">
        <ActiveChip :item="item" />
      </template>

      <template v-slot:item._updated="{ item }">
        <span>{{ formatDate(item._updated) }} </span>
      </template>

      <template v-slot:item.Duplicate="{ item }">
        <v-icon small class="mr-2" @click="Duplicate(item, 'Duplicate')">
          mdi-content-duplicate
        </v-icon>
      </template>

      <template v-slot:item.ModifyMarginalCost="{ item }">
        <v-icon small @click="openModifyMarginalCost(item)">
          mdi-pencil
        </v-icon>
      </template>

      <template v-slot:item.Modify="{ item }">
        <v-icon small @click="openNewWindow(item)"> mdi-pencil </v-icon>
      </template>
      <template v-slot:item.view="{ item }">
        <v-icon small @click="openDetailwindow(item)"> mdi-eye </v-icon>
      </template>
      <template v-slot:item.delete="{ item }">
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>

   <template v-slot:item.custom_action="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="
                (item.status !== 'analysis_ready_der' &&
                  item.status !== 'analysis_completed') ||
                item.analysisStatus === 'analysis_failed'
              "
              icon
              v-bind="attrs"
              v-on="on"
              small
              @click="openNewWindow(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>

            <v-btn
              v-if="
                (item.status === 'analysis_completed' ||
                  item.status === 'analysis_ready_der') &&
                item.analysisStatus !== 'analysis_failed'
              "
              icon
              v-bind="attrs"
              v-on="on"
              small
              @click="openDetailwindow(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>View/Edit</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ml-4"
              icon
              small
              v-bind="attrs"
              v-on="on"
              @click="publish(item)"
              :disabled="!isPublishActionEnabled(item)"
            >
              <v-icon> mdi-publish </v-icon>
            </v-btn>
          </template>
          <span v-if="item.isPublished">Unpublish</span>
          <span v-if="!item.isPublished">Publish</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              v-bind="attrs"
              v-on="on"
              class="ml-4"
              @click="deleteItem(item)"
            >
              <v-icon> mdi-delete </v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>

      <template v-slot:item.action="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="
                (item.status !== 'analysis_ready_der' &&
                  item.status !== 'analysis_completed') ||
                item.analysisStatus === 'analysis_failed'
              "
              icon
              v-bind="attrs"
              v-on="on"
              small
              @click="openNewWindow(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>

            <v-btn
              v-if="
                (item.status === 'analysis_completed' ||
                  item.status === 'analysis_ready_der') &&
                item.analysisStatus !== 'analysis_failed'
              "
              icon
              v-bind="attrs"
              v-on="on"
              small
              @click="openDetailwindow(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>View/Edit</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ml-4"
              icon
              small
              v-bind="attrs"
              v-on="on"
              @click="publish(item)"
              :disabled="!isPublishActionEnabled(item)"
            >
              <v-icon> mdi-publish </v-icon>
            </v-btn>
          </template>
          <span v-if="item.isPublished">Unpublish</span>
          <span v-if="!item.isPublished">Publish</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ml-4"
              icon
              v-bind="attrs"
              v-on="on"
              small
              @click="cloneProject(item)"
            >
              <v-icon>mdi-content-duplicate</v-icon>
            </v-btn>
          </template>
          <span>Duplicate</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              v-bind="attrs"
              v-on="on"
              class="ml-4"
              @click="deleteItem(item)"
            >
              <v-icon> mdi-delete </v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
      <template v-slot:item._isPublished="{ item }">
        <v-icon small class="mr-4" @click="publish(item)"> mdi-publish </v-icon>
      </template>

      <template v-slot:item.Download="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              v-bind="attrs"
              v-on="on"
              @click="downloadCSV(item.csvFile.file, item.title)"
            >
              <v-icon>mdi-arrow-collapse-down</v-icon>
            </v-btn>
          </template>
          <span>Download</span>
        </v-tooltip>
      </template>

      <template v-slot:item.Report="{ item }">
        <v-btn
          text
          class="text-capitalize"
          router
          :to="`/report/${item.reportId}`"
          :disabled="isReportActionEnabled(item)"
          >View</v-btn
        >
        <!-- <v-btn
          text
          class="text-capitalize"
          :disabled="isReportActionEnabled(item)"
          @click="downloadCSV(item.csvFile.file, item.title)"
          >Download</v-btn
        > -->
      </template>
    </v-data-table>

    <div v-if="showMarginalCost">
      <NewEditMarginCostReplaced
        :visible="showMarginalCost"
        @close="closeWindow"
        WindowLable="Edit Marginal Cost Of Replaced Energy"
        :EditMode="true"
        :MarginalData="marginalData"
        :source="dataSource"
      />
    </div>

    <ConfirmationBox
      confirmationTitle="Delete"
      :visible="ShowDeleteConfirmation"
      @close="deleteConfirm"
      bodyText="Are you sure you want to delete?"
    />

    <div v-if="editvisible">
      <NewEditProject
        :visible="editvisible"
        @close="closeWindow"
        WindowLable="Edit Project"
        :ProjectData="marginalData"
        :EditMode="true"
      />
    </div>

    <!-- <div v-if="popupObject.find((w) => w.value === 'user-projects'  ).visible">
      <NewEditProject
        :visible="popupObject.find((w) => w.value === 'user-projects').visible"
        @close="closeWindow"
        WindowLable="Edit Project"
        :ProjectData="marginalData"
        :EditMode="true"
      />
    </div> -->
    <!-- 
    <div v-if="popupObject.find((w) => w.value === 'projects' ).visible">
      <NewEditProject
        :visible="popupObject.find((w) => w.value === 'projects').visible"
        @close="closeWindow"
        WindowLable="Edit Project"
        :ProjectData="marginalData"
        :EditMode="true"
      />
    </div> -->
    <div v-if="isDetaisView">
      <viewProject
        :ProjectData="marginalData"
        :visible="isDetaisView"
        @close="closeWindow"
        WindowLable="Project Details"
      />
    </div>
  </div>
</template>
<script>
import { bus } from "../main";
import jsPDF from "jspdf";
import DataList from "@/services/dataliststore.js";
import ProjectService from "@/services/ProjectService";
import dataService from "@/libs/dataService";
import ProjectStatusChip from "@/components/projectStatusChip.vue";
import PublishedChip from "@/components/publishedStatusChip.vue";
import ActiveChip from "@/components/activeChip.vue";
import ConfirmationBox from "@/components/deleteConfirmation.vue";
import { formatDate } from "@/utility/dateTime";
import NewEditMarginCostReplaced from "@/components/newEditMarginalCost.vue";
import NewEditProject from "@/components/neweditproject.vue";
import viewProject from "@/components/projectDetails.vue";
import { downloadCSV } from "@/services/csvDownload";
import settingsUtility from "@/utility/settingsUtility";
import { projectStatus } from "../utility/constants";

export default {
  name: "DataTable",
  props: [
    "projects",
    "Loading",
    "source",
    "headers",
    "isShowProjectDetails",
    "bordered",
  ],
  components: {
    NewEditMarginCostReplaced,
    ConfirmationBox,
    PublishedChip,
    ActiveChip,
    NewEditProject,
    ProjectStatusChip,
    viewProject,
  },
  data() {
    return {
      pagination: {
        rowsPerPage: 5,
      },
      showMarginalCost: false,
      editvisible: false,
      isDetaisView: false,
      allowPublish: false,
      dataSource: "",
      formatDate: formatDate,
      downloadCSV: downloadCSV,
      deleteItemObj: "",
      isConfirmed: false,
      ShowDeleteConfirmation: false,
      showEditwProjectForm: false,
      marginalData: [],
      responseData: [],
      timeout: 2000,
      color: "",
      errorMsg: "",
      Notification: false,
      showForm: false,
      showEditForm: false,
      showNewMarginWindow: false,
      popupObject: [
        {
          value: "user-projects",
          dataSource: this.marginalData,
          visible: false,
        },
        {
          value: "projects",
          dataSource: this.marginalData,
          visible: false,
        },

        {
          value: "marginalCostOfReplacedEnergyRecords",
          dataSource: this.marginalData,
          visible: false,
        },
      ],
    };
  },
  mounted() {
    this.isPublishActionAllowed();
  },
  created() {
    bus.$on("justAdded", (data) => {
      this.projects.push(data);
    });
    bus.$on("justEdited", (data) => {
      let idx = -1;
      const newProjects = this.projects.map((p) => p);
      newProjects.forEach((element, index) => {
        if (element._id === data._id) {
          idx = index;
        }
      });
      if (idx !== -1) {
        newProjects[idx] = { ...data };
        this.projects = newProjects;
      }
    });
  },
  methods: {
    async cloneProject(item) {
      ProjectService.cloneProject(item._id).then((res) => {
        bus.$emit("cloneNotification", "OK", res.status, "Project");
        const projectId = res.data._id;
        this.editClonedProject(projectId).then((res) => {
          this.openNewWindow(res[0]);
        });
      });
    },
    async editClonedProject(id) {
      return DataList.methods.fetchData(`user-projects?where={"_id":"${id}"}`);
      // return DataList.methods.fetchData(`user-projects?_id="${id}"}`);
    },
    isReportActionEnabled(item) {
      if (
        item.status === projectStatus.ANALYSIS_COMPLETED &&
        item.reportId !== undefined
      ) {
        return false;
      }
      return true;
    },
    navigateToProjectView(item) {
      this.$router.push({
        name: "projectDetails",
        params: item,
      });
    },
    isPublishActionAllowed() {
      const data = settingsUtility.methods.getData();
      if (data && data.settings) {
        if (data.settings.isProjectInfoShareable === true) {
          this.allowPublish = true;
          return;
        }
      }
      this.allowPublish = false;
    },
    isPublishActionEnabled(item) {
      return (
        this.allowPublish && item.status === projectStatus.ANALYSIS_COMPLETED
      );
    },
    createPDF(item) {
      let pdfName = item.Title;
      var doc = new jsPDF();
      var temp = [
        "id : " + item.id.toString(),
        "Title :" + item.Title.toString(),
        "Date : " + item.Date.toString(),
        "Status : " + item.Status.toString(),
        "Published : " + item.isPublished.toString(),
      ];

      doc.text(temp, 10, 10);
      doc.save(pdfName + ".pdf");
    },
    setVisible(visible, item) {
      //   this.editvisible=true;
      this.marginalData = item;

      const objIndex = this.popupObject.findIndex(
        (obj) => obj.value == this.source
      );

      this.popupObject[objIndex].visible = visible;

      // if(objIndex>0){
      //   this.popupObject[objIndex].visible = visible;
      // }
      // else
      // {
      //   this.openDetailwindow(item);
      // }
    },
    openDetailwindow(item) {
      this.isDetaisView = true;
      this.marginalData = item;
    },
    openNewWindow(item) {
       this.marginalData = item;
       this.editvisible = true;
      // if (item) {
      //   this.marginalData = item;
      //   this.editvisible = true;
      // } else {
      //   console.log("response delayed");
      // }
      
    },

    openModifyMarginalCost(item) {
      this.marginalData = item;
      this.showMarginalCost = true;
    },

    closeWindow(e) {
      this.$router.go(this.$router.currentRoute);
      //this.setVisible(false,null);
      this.editvisible = false;
      this.showNewMarginWindow = false;

      this.showForm = false;
      this.responseData = e;
    },
    getColor(Status) {
      if (Status === false) return "red";
      else return "green";
    },
    viewItem() {
      // console.log("view item", item);
      this.$router.go(this.$router.currentRoute);
    },
    doDelete(item) {
      dataService.delete(this.source, item._id).then((res) => {
        const _status = res.status == "204" ? "OK" : "";
        bus.$emit("deleteNotification", _status);
        if (_status === "OK") {
          this.projects.splice(this.projects.indexOf(item), 1);
        }
      });
    },
    publish(item) {
      this.loading = true;
      dataService
        .doPublish(this.source, item._id, !item.isPublished)
        .then((res) => {
          this.loading = false;
          item.isPublished = !item.isPublished;
          bus.$emit(
            "publishNotification",
            item.isPublished,
            res.data._status,
            ""
          );
        });
    },
    deleteItem(item) {
      this.deleteItemObj = item;
      this.ShowDeleteConfirmation = true;
    },

    deleteConfirm(e) {
      this.ShowDeleteConfirmation = false;
      this.isConfirmed = e;
      if (e) {
        this.doDelete(this.deleteItemObj);
      }
    },
  },
};
</script>
